// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminMobileNavController from "./admin_mobile_nav_controller"
application.register("admin-mobile-nav", AdminMobileNavController)

import AdminTabsController from "./admin_tabs_controller"
application.register("admin-tabs", AdminTabsController)

import AutoFilterController from "./auto_filter_controller"
application.register("auto-filter", AutoFilterController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AutosaveNotificationController from "./autosave_notification_controller"
application.register("autosave-notification", AutosaveNotificationController)

import BulkSyncController from "./bulk_sync_controller"
application.register("bulk-sync", BulkSyncController)

import BusinessInfoWatcherController from "./business_info_watcher_controller"
application.register("business-info-watcher", BusinessInfoWatcherController)

import BusinessMatchSelectorController from "./business_match_selector_controller"
application.register("business-match-selector", BusinessMatchSelectorController)

import BusinessVerificationController from "./business_verification_controller"
application.register("business-verification", BusinessVerificationController)

import CfaPollerController from "./cfa_poller_controller"
application.register("cfa-poller", CfaPollerController)

import CfaRetryController from "./cfa_retry_controller"
application.register("cfa-retry", CfaRetryController)

import CashflowFilterController from "./cashflow_filter_controller"
application.register("cashflow-filter", CashflowFilterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import SubmitGateController from "./submit_gate_controller"
application.register("submit-gate", SubmitGateController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import ConversionOptimizerController from "./conversion_optimizer_controller"
application.register("conversion-optimizer", ConversionOptimizerController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import DrawerSelectController from "./drawer_select_controller"
application.register("drawer-select", DrawerSelectController)

import ProductSelectController from "./product_select_controller"
application.register("product-select", ProductSelectController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EinFormatterController from "./ein_formatter_controller"
application.register("ein-formatter", EinFormatterController)

import EditEmailController from "./edit_email_controller"
application.register("edit-email", EditEmailController)

import EmailMismatchWarningController from "./email_mismatch_warning_controller"
application.register("email-mismatch-warning", EmailMismatchWarningController)

import ExportModalController from "./export_modal_controller"
application.register("export-modal", ExportModalController)

import FieldMappingsImportController from "./field_mappings_import_controller"
application.register("field-mappings-import", FieldMappingsImportController)

import FieldPopulatorController from "./field_populator_controller"
application.register("field-populator", FieldPopulatorController)

import FieldSelectorController from "./field_selector_controller"
application.register("field-selector", FieldSelectorController)

import FieldValidatorController from "./field_validator_controller"
application.register("field-validator", FieldValidatorController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FullstorySessionCaptureController from "./fullstory_session_capture_controller"
application.register("fullstory-session-capture", FullstorySessionCaptureController)

import FlashMessagesController from "./flash_messages_controller"
application.register("flash-messages", FlashMessagesController)

import FormSelectController from "./form_select_controller"
application.register("form-select", FormSelectController)

import FormValidatorController from "./form_validator_controller"
application.register("form-validator", FormValidatorController)

import GtmTrackingController from "./gtm_tracking_controller"
application.register("gtm-tracking", GtmTrackingController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImportModalController from "./import_modal_controller"
application.register("import-modal", ImportModalController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LendflowEnvironmentsController from "./lendflow_environments_controller"
application.register("lendflow-environments", LendflowEnvironmentsController)

import LiveCounterController from "./live_counter_controller"
application.register("live-counter", LiveCounterController)

import LoanFormController from "./loan_form_controller"
application.register("loan-form", LoanFormController)

import MagicLinkController from "./magic_link_controller"
application.register("magic-link", MagicLinkController)

import ManualFilterController from "./manual_filter_controller"
application.register("manual-filter", ManualFilterController)

import MobileSidebarController from "./mobile_sidebar_controller"
application.register("mobile-sidebar", MobileSidebarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import MultiSelectDropdownController from "./multi_select_dropdown_controller"
application.register("multi-select-dropdown", MultiSelectDropdownController)

import MultiSelectFilterController from "./multi_select_filter_controller"
application.register("multi-select-filter", MultiSelectFilterController)

import MultiStepFormController from "./multi_step_form_controller"
application.register("multi-step-form", MultiStepFormController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import OtpVerificationController from "./otp_verification_controller"
application.register("otp-verification", OtpVerificationController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PerformanceDashboardController from "./performance_dashboard_controller"
application.register("performance-dashboard", PerformanceDashboardController)

import PhoneFormatterController from "./phone_formatter_controller"
application.register("phone-formatter", PhoneFormatterController)

import PlaidLinkController from "./plaid_link_controller"
application.register("plaid-link", PlaidLinkController)

import PreferenceToggleController from "./preference_toggle_controller"
application.register("preference-toggle", PreferenceToggleController)

import ProfileEditController from "./profile_edit_controller"
application.register("profile-edit", ProfileEditController)

import ProfileSettingsController from "./profile_settings_controller"
application.register("profile-settings", ProfileSettingsController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import ProgressTrackerController from "./progress_tracker_controller"
application.register("progress-tracker", ProgressTrackerController)

import ProgressiveDisclosureController from "./progressive_disclosure_controller"
application.register("progressive-disclosure", ProgressiveDisclosureController)

import ProgressiveSyncController from "./progressive_sync_controller"
application.register("progressive-sync", ProgressiveSyncController)

import RegistrationOtpController from "./registration_otp_controller"
application.register("registration-otp", RegistrationOtpController)

import RevenueVerificationController from "./revenue_verification_controller"
application.register("revenue-verification", RevenueVerificationController)

import RevenueVerificationPollController from "./revenue_verification_poll_controller"
application.register("revenue-verification-poll", RevenueVerificationPollController)

import RoleManagementController from "./role_management_controller"
application.register("role-management", RoleManagementController)

import SalesforceController from "./salesforce_controller"
application.register("salesforce", SalesforceController)

import SidebarMenuController from "./sidebar_menu_controller"
application.register("sidebar-menu", SidebarMenuController)

import SalesforceEnvironmentFormController from "./salesforce_environment_form_controller"
application.register("salesforce-environment-form", SalesforceEnvironmentFormController)

import SalesforceEnvironmentsController from "./salesforce_environments_controller"
application.register("salesforce-environments", SalesforceEnvironmentsController)

import SalesforceStatusController from "./salesforce_status_controller"
application.register("salesforce-status", SalesforceStatusController)

import SalesforceValidateController from "./salesforce_validate_controller"
application.register("salesforce-validate", SalesforceValidateController)

import SampleDataController from "./sample_data_controller"
application.register("sample-data", SampleDataController)

import SaveForLaterController from "./save_for_later_controller"
application.register("save-for-later", SaveForLaterController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SmartystreetsAutocompleteController from "./smartystreets_autocomplete_controller"
application.register("smartystreets-autocomplete", SmartystreetsAutocompleteController)

import SsnMaskController from "./ssn_mask_controller"
application.register("ssn-mask", SsnMaskController)

import SubmitConsentController from "./submit_consent_controller"
application.register("submit-consent", SubmitConsentController)

import StatusRefreshController from "./status_refresh_controller"
application.register("status-refresh", StatusRefreshController)

import SyncNotificationController from "./sync_notification_controller"
application.register("sync-notification", SyncNotificationController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TransactionDetailsController from "./transaction_details_controller"
application.register("transaction-details", TransactionDetailsController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import VerificationMethodToggleController from "./verification_method_toggle_controller"
application.register("verification-method-toggle", VerificationMethodToggleController)

import WatchlistDetailsController from "./watchlist_details_controller"
application.register("watchlist-details", WatchlistDetailsController)

import PartnerMetricsController from "./partner_metrics_controller"
application.register("partner-metrics", PartnerMetricsController)
